import { render, staticRenderFns } from "./detail-linkaja.vue?vue&type=template&id=2877c874&"
import script from "./detail-linkaja.vue?vue&type=script&lang=js&"
export * from "./detail-linkaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports